/**
 * Logique OTP côté client (miroir de backend phone-routing.util.js pour l'UX).
 */

const VOICE_PRIMARY_COUNTRIES = new Set(['US', 'CA']);

/** @returns {'sms' | 'voice'} */
export function selectPrimaryOtpChannel(countryCode) {
  const cc = (countryCode || '').toUpperCase();
  if (VOICE_PRIMARY_COUNTRIES.has(cc)) {
    return 'voice';
  }
  return 'sms';
}

/** @param {'sms' | 'voice' | 'email'} channel */
export function getOtpFallbackChannel(channel, countryCode) {
  const cc = (countryCode || '').toUpperCase();
  if (channel === 'sms') return 'voice';
  if (channel === 'voice' && VOICE_PRIMARY_COUNTRIES.has(cc)) return 'email';
  return null;
}

export function isVoicePrimaryCountry(countryCode) {
  return VOICE_PRIMARY_COUNTRIES.has((countryCode || '').toUpperCase());
}

export function describePrimaryOtpChannel(countryCode) {
  const primary = selectPrimaryOtpChannel(countryCode);
  if (primary === 'voice') {
    return {
      primary: 'voice',
      hint: 'Vous recevrez un appel vocal qui dictera votre code. Répondez à l\'appel.',
      fallbackLabel: 'Recevoir le code par email',
    };
  }
  return {
    primary: 'sms',
    hint: 'Un code sera envoyé par SMS. Vérifiez votre téléphone.',
    fallbackLabel: 'Recevoir le code par appel vocal',
  };
}
